import React from "react";
import Table from "../../Common/Table";

import TableFields from "../../../constants/Telecallers/TableFields.json";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";

const TelecallersList = (props) => {
  const { telecallersList, handleClick } = props;
  const allActions = MenuActionsMappings[MenuNames.TELECALLER_PROFILE];

  const getFieldValue = (item, key) => {
    const isPresentInLMS = item["present_in_lms"];
    const authId = item["auth_detail_id"];
    switch (key) {
      case "actions":
        return isPresentInLMS ? (
          <Permission
            requiredPerms={[allActions.CREATE, allActions.EDIT]}
            notAllowedText="No Allowed Actions"
          >
            <span
              onClick={() => handleClick(isPresentInLMS, authId)}
              className="edit-options cursor-pointer"
            >
              View/Edit Profile
            </span>
          </Permission>
        ) : (
          <Permission
            requiredPerms={[allActions.CREATE]}
            notAllowedText="No Allowed Actions"
          >
            <span
              onClick={() => handleClick(isPresentInLMS, authId)}
              className="edit-options cursor-pointer"
            >
              Create Profile
            </span>
          </Permission>
        );
      case "present_in_lms":
        return <span className="pill">{item[key] ? "Yes" : "No"}</span>;
      default:
        return item[key];
    }
  };

  return (
    <Table
      list={telecallersList}
      getFieldValue={getFieldValue}
      fields={TableFields}
    />
  );
};

export default TelecallersList;
